module.exports = __webpack_public_path__ + "static/stage2-thumb-546eb33b289fbd1409baea93620c64ae.jpg";